import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild, ElementRef } from '@angular/core';
import { isMac } from '@local/common-web';
import { isKey, keyCodes } from '@local/ts-infra';

@Component({
  selector: 'input-popup',
  templateUrl: './input-popup.component.html',
  styleUrls: ['./input-popup.component.scss'],
})
export class InputPopupComponent implements OnInit {
  @Input() model: { to: Array<string>; cc?: Array<string>; replyAll: boolean };

  @Output() proceed = new EventEmitter<any>();
  @Output() close = new EventEmitter<any>();

  @ViewChild('textarea') textarea: ElementRef;

  shortcutAccelerator = isMac() ? 'command' : 'Control';
  inProgress = false;

  inputs = {
    body: null,
    replyAll: false,
  };

  ngOnInit(): void {
    this.inputs = {
      body: null,
      replyAll: this.model.replyAll || false,
    };
  }

  ngAfterViewInit() {
    (this.textarea.nativeElement as HTMLDivElement).focus();
  }

  @HostListener('click', ['$event'])
  onHostClick(e: MouseEvent) {
    if ((e.target as HTMLElement).tagName === 'INPUT-POPUP') {
      this.close.emit();
    }
  }

  updateBody(event: InputEvent) {
    const element = event.target as HTMLDivElement;
    const value = element.innerText.trim();
    this.inputs.body = value;
  }

  textareaKeyDown(event: KeyboardEvent) {
    if (isKey(event, keyCodes.enter) && (event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      this.onProceed();
      return;
    }

    if (isKey(event, keyCodes.escape)) {
      this.onClose();
    }
  }

  async onProceed() {
    this.proceed.emit(this.inputs);
  }

  onClose() {
    this.close.emit();
  }
}
